export function FounderBadge({ tier, size = 16 }) {
  if (tier === 'founder') {
    return (
      <img
        src="/images/founder-badge.png"
        alt="Founder"
        title="Founder Member"
        className="inline-block shrink-0"
        style={{ width: size, height: size }}
        data-testid="founder-badge"
      />
    );
  }
  if (tier === 'pro') {
    return (
      <img
        src="/images/pro-badge.png"
        alt="Pro"
        title="Pro Member"
        className="inline-block shrink-0"
        style={{ width: size, height: size }}
        data-testid="pro-badge"
      />
    );
  }
  return null;
}
